/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type ICustodianProfileQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;

export type ICustodianProfileQuery = {
  __typename?: 'Query';
  custodianProfile?: {
    __typename?: 'CustodianProfile';
    id: string;
    name: string;
    status: Types.CustodianProfileStatusEnum;
    createdAt: any;
    updatedAt: any;
    activatedAt?: any | null;
    custodianAssets: Array<{
      __typename?: 'CustodianAsset';
      id: string;
      name: string;
      operationalStatus: Types.CustodianAssetOperationalStatusEnum;
      externalId: string;
      custodianStatus: Types.CustodianAssetCustodianStatusEnum;
      updatedAt: any;
      custodianIntegration: {
        __typename?: 'CustodianIntegration';
        id: string;
        integration: { __typename?: 'OauthIntegration'; id: string; provider: string; accountName?: string | null };
      };
    }>;
    custodianIntegrations: Array<{
      __typename?: 'CustodianIntegration';
      id: string;
      status: Types.CustodianIntegrationStatusEnum;
      updatedAt: any;
      integration: { __typename?: 'OauthIntegration'; id: string; provider: string; accountName?: string | null };
      custodianAssets: Array<{
        __typename?: 'CustodianAsset';
        id: string;
        name: string;
        operationalStatus: Types.CustodianAssetOperationalStatusEnum;
        externalId: string;
        custodianStatus: Types.CustodianAssetCustodianStatusEnum;
      }>;
    }>;
    custodianOperations: Array<{
      __typename?: 'CustodianOperation';
      id: string;
      custodianServiceEvents: Array<Types.CustodianOperationCustodianServiceEventEnum>;
      custodianServiceEventsCustom?: string | null;
      dataRetention?: number | null;
      endOfRetentionPeriod: Types.CustodianOperationEndOfRetentionPeriodEnum;
      endOfRetentionPeriodCustom?: string | null;
      operationType: Types.CustodianOperationTypeEnum;
      operationTypeCustom?: string | null;
      regulatoryRequirements: Array<Types.CustodianOperationRegulatoryRequirementsEnum>;
      regulatoryRequirementsCustom?: string | null;
    }>;
    policy: {
      __typename?: 'CustodianProfilePolicy';
      activate: boolean;
      remove: boolean;
      requestTermination: boolean;
      submitForReview: boolean;
      update: boolean;
    };
    creator?: { __typename?: 'User'; id: string; name?: string | null } | null;
    app: { __typename?: 'App'; id: string; name?: string | null };
    company: { __typename?: 'Company'; id: string; companyWebsite?: string | null };
    custodianTermination?: {
      __typename?: 'CustodianTermination';
      id: string;
      status: Types.CustodianTerminationStatusEnum;
    } | null;
  } | null;
};

export const CustodianProfileDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'custodianProfile' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custodianProfile' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'custodianProfileId' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'FragmentSpread', name: { kind: 'Name', value: 'CustodianProfileBaseFields' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custodianAssets' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operationalStatus' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'custodianStatus' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'custodianIntegration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'integration' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                                  { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custodianIntegrations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'integration' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'provider' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'accountName' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'custodianAssets' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'operationalStatus' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalId' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'custodianStatus' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'custodianOperations' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'custodianServiceEvents' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'custodianServiceEventsCustom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'dataRetention' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endOfRetentionPeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'endOfRetentionPeriodCustom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operationType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'operationTypeCustom' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRequirements' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'regulatoryRequirementsCustom' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'activate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'remove' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestTermination' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'submitForReview' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'creator' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'app' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'CustodianProfileBaseFields' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'CustodianProfile' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'name' } },
          { kind: 'Field', name: { kind: 'Name', value: 'status' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'company' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'companyWebsite' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custodianTermination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custodianAssets' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custodianIntegrations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'custodianOperations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'policy' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [{ kind: 'Field', name: { kind: 'Name', value: 'remove' } }],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'createdAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'updatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'activatedAt' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ICustodianProfileQuery, ICustodianProfileQueryVariables>;
